






import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import Exam from '../../models/exam'
import { ROUTER_NAME } from '../../router'
import api from '../../../api/v2/api'
import User from '../../models/user'

@Component({
  components: {}
})
export default class ExamButton extends Vue {
  @Prop({ required: true }) exam: Exam
  @Prop({ required: true }) user: User
  private buttonState: 'Apply' | 'Buy' | 'Continue' | 'Result' = 'Apply'

  get title() {
    const userExam = this.exam.userExams.find(userExam => userExam.userId == this.user.id)
    if (userExam) {
      if (userExam.finishedAt) {
        this.buttonState = 'Result'
        return 'WEBテストの結果をみる'
      }
      this.buttonState = 'Continue'
      return 'WEBテストを受け続ける'
    }

    if (this.exam.price && !this.user.hasExamSubscription) {
      this.buttonState = 'Buy'
      return `${this.exam.price.toLocaleString()}円でWEBテストを受ける`
    }
    this.buttonState = 'Apply'
    return '今すぐWEBテストを受ける'
  }

  async buttonAction() {
    switch(this.buttonState) {
      case 'Apply':
        await api.exam.join(this.exam.id)
        return this.$router.push({
          name: ROUTER_NAME.EXAM_SHOW,
          params: {
            examId: this.exam.id.toString()
          }
        })
        break
      case 'Buy':
        return this.$router.push({
          name: ROUTER_NAME.EXAM_PURCHASE,
          params: {
            examId: this.exam.id.toString()
          }
        })
      case 'Continue':
        return this.$router.push({
          name: ROUTER_NAME.EXAM_SHOW,
          params: {
            examId: this.exam.id.toString()
          }
        })
      case 'Result':
        return this.$router.push({
          name: ROUTER_NAME.EXAM_RESULT,
          params: {
            examId: this.exam.id.toString()
          },
          query: {
            user_exam_id: this.exam.userExam.id.toString()
          },
        })
    }
  }
}
